import { useEffect, useState } from "react";
import Product from "../../assets/images/Image 2.png";
import renameimg from "../../assets/images/rename.svg";
import { FormatValueDecimal, CurrencyConvertion, calculateNetPrice } from "../../utils/Validate";
import { GetList } from "../../providers/dataProvider";

const getOrderProductId = (item) => item?.orderProductId ?? item?.id;
const getQuoteProductId = (item) => item?.quoteProductId ?? item?.id;

const OrderProductList = ({
    values,
    currencyDetail,
    EditOrderQuantity,
    rename,
    renameError,
    setOrderProductCount,
    onRename,
    onRenameBlur,
    onRenameChange,
    onRenameKeyDown,
}) => {
    const [balancedQt, setBalancedQt] = useState([]);

    const orderProducts = values?.products || [];
    const balanceProducts = Array.isArray(balancedQt?.data) ? balancedQt.data : [];
    const productRows = [
        ...orderProducts.map((item) => {
            const balanceMatch = balanceProducts.find(
                (b) => getQuoteProductId(b) === getQuoteProductId(item)
            );
            const correctedQuotedQuantity =
                balanceMatch?.quotedQuantity ?? item?.quotedQuantity ?? item?.quantity;

            return {
                ...item,
                quotedQuantity: correctedQuotedQuantity,
                __isSavedOrderMark: true,
            };
        }),
        ...balanceProducts
            .filter((item) => !orderProducts.some((product) => getQuoteProductId(product) === getQuoteProductId(item)))
            .map((item) => ({ ...item, __isSavedOrderMark: false })),
    ];

    useEffect(() => {
        if (!values?.quotationId) {
            setOrderProductCount(0);
            return;
        }
        GetList("quotebalance", { id: values?.quotationId }, setBalancedQt);
    }, [values?.quotationId, setOrderProductCount]);

    useEffect(() => {
        setOrderProductCount(productRows?.length || 0);
    }, [productRows?.length, setOrderProductCount]);

    return (
        <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-12 col-sm-12 col-xs-12 center-card order-products-grid-card">
            <div className="card">
                <div className="card-body p-0">
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table table-borderless order-products-grid">
                                    <thead>
                                        <tr>
                                            <th>Mark</th>
                                            <th>Model Number</th>
                                            <th>Quote Quantity</th>
                                            <th>Released Quantity</th>
                                            <th>LPO Quantity</th>
                                            <th>List Price</th>
                                            <th>Margin</th>
                                            <th>Net Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productRows?.length > 0 ? productRows?.map((item, index) => {
                                            const isSavedOrderMark = item?.__isSavedOrderMark === true;
                                            const isSavedOrderMarkFalse = item?.__isSavedOrderMark === false;
                                            return (
                                                <tr key={item?.id || index} aria-disabled={!isSavedOrderMark}>
                                                    <td className="product-mark-cell">
                                                        <div className="product-mark-main">
                                                            <div className="product-mark-thumb" aria-hidden="true">
                                                                <img src={Product} alt="" />
                                                            </div>

                                                            <span
                                                                className="product-mark-link"
                                                                title={item?.markName}
                                                                role="button"
                                                                tabIndex={0}
                                                                onClick={() => {
                                                                    console.log("Mark clicked:", item);
                                                                    EditOrderQuantity(item);
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                        e.preventDefault();
                                                                        EditOrderQuantity(item);
                                                                    }
                                                                }}
                                                            >
                                                                {item?.markName}
                                                            </span>

                                                            <div className="product-mark-actions">
                                                                <button
                                                                    type="button"
                                                                    title="Rename"
                                                                    disabled={!isSavedOrderMark}
                                                                    onClick={() => onRename && onRename(item)}
                                                                >
                                                                    <img src={renameimg} alt="Rename" />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* Inline rename input — shown only for the row currently being renamed */}
                                                        {isSavedOrderMark && rename && getOrderProductId(rename) === getOrderProductId(item) && (
                                                            <div className="product-mark-rename-row mt-1">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    value={rename?.markName ?? ""}
                                                                    autoFocus
                                                                    onChange={(e) =>
                                                                        onRenameChange && onRenameChange({ ...rename, markName: e.target.value })
                                                                    }
                                                                    onBlur={() => onRenameBlur && onRenameBlur()}
                                                                    onKeyDown={(e) => onRenameKeyDown && onRenameKeyDown(e)}
                                                                />
                                                                {renameError && <p className="form-error">{renameError}</p>}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{ textAlign: "left" }}>{item?.productName}</td>
                                                    <td style={{ textAlign: "right" }}>{item?.quotedQuantity ?? item?.quoteQuantity}</td>
                                                    <td style={{ textAlign: "right" }}>{item?.orderedQuantity ?? item?.customerOrderedQuantity ?? 0}</td>
                                                    <td style={{ textAlign: "right" }}> {isSavedOrderMarkFalse ? "0" : (item?.currentOrderQuantity ?? 0)}</td>
                                                    <td style={{ textAlign: "right" }}>{isSavedOrderMarkFalse ? "0" : FormatValueDecimal(CurrencyConvertion(item?.listPrice, values?.conversionRate, currencyDetail))}</td>
                                                    <td style={{ textAlign: "right" }}>{item?.margin}</td>
                                                    <td style={{ textAlign: "right" }}>{isSavedOrderMarkFalse ? "0" : FormatValueDecimal(CurrencyConvertion(item?.sellingPrice, values?.conversionRate, currencyDetail))}</td>
                                                </tr>
                                            )
                                        }) : (
                                            <tr>
                                                <td colSpan="9">
                                                    <div className="order-products-empty-state">
                                                        <strong>No marks added yet</strong>
                                                        <span>Select a quotation to load product marks for this order.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion account-summary-accordion my-2" id="orderaccSummaryAccordion">
                                <div className="card account-summary-card">
                                    <div className="card-header" id="headingTwo">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link btn-block text-left account-summary-accordion-toggle"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseOne"
                                                aria-expanded="true"
                                                aria-controls="collapseOne"
                                            >
                                                <i className="fas fa-file-alt account-summary-accordion-icon" aria-hidden="true"></i>
                                                <span>Account Summary</span>
                                            </button>
                                        </h2>
                                    </div>

                                    <div
                                        id="collapseOne"
                                        className="collapse"
                                        aria-labelledby="headingOne"
                                        data-parent="#orderaccSummaryAccordion"
                                    >
                                        <div className="card-body">
                                            <div className="row account-summary-metrics m-2">
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Credit Limit</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Outstanding</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Overdue</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Pending Orders</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Pending Delivery</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Available Room</label>
                                                    <p>0</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderProductList;
